import script from "./CalendarHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarHeader.vue?vue&type=script&setup=true&lang=js"

import "./CalendarHeader.vue?vue&type=style&index=0&id=c2e376b2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2e376b2"]])

export default __exports__